export interface HRReportResponse {
  report_type: string
  report_name: string
  period: { from: string; to: string }
  group_by?: string
  summary: Record<string, number | string>
  data: Record<string, unknown>[]
  generated_at: string
}

export interface HRFilterPresetResponse {
  presets: Array<{
    id: string
    name: string
    category: string
    filters: Record<string, unknown>
    is_public: boolean
  }>
  total: number
}

export interface HRComparisonResponse {
  current_period: { total: number }
  previous_period: { total: number } | null
  changes: { total: number } | null
  generated_at: string
}

export interface FilterPresetSave {
  name: string
  category: string
  filters: Record<string, unknown>
  is_public: boolean
}

export interface HRComparisonPeriodSave {
  comparison_name: string
  current_period_from: string
  current_period_to: string
  current_period_label: string
  comparison_period_from: string
  comparison_period_to: string
  comparison_period_label: string
  comparison_type: string
}

export interface HRComparisonPeriodResponse {
  id: string
  comparison_name: string
  current_period_from: string
  current_period_to: string
  current_period_label: string
  comparison_period_from: string
  comparison_period_to: string
  comparison_period_label: string
  comparison_type: string
  last_used_at: string | null
}

export interface HRAdjustmentCreate {
  target_type: string
  target_id: string
  field_name: string
  new_value: string
  adjustment_reason: string
  adjustment_category: string
  is_soft_delete?: boolean
  soft_delete_reason?: string
}

export interface HRAdjustmentResponse {
  id: string
  target_type: string
  target_id: string
  field_name: string
  old_value: string | null
  new_value: string
  adjustment_reason: string
  adjustment_category: string
  performed_by_name: string
  performed_by_role: string
  is_soft_delete: boolean
  created_at: string
}

export type ChartType = 'bar' | 'line' | 'area' | 'pie'
export type ViewMode = 'chart' | 'table' | 'both'

export const REPORTS = [
  { key: 'total_angefragt_besetzt', label: 'Total Angefragt & Besetzt' },
  { key: 'total_substituiert', label: 'Total Substituiert' },
  { key: 'zeit_substituiert_nach_lehrer', label: 'Zeit Substituiert nach Lehrer' },
  { key: 'zeit_angefragt_nach_lehrer', label: 'Zeit Angefragt nach Lehrer' },
  { key: 'lektionen_mit_verwaltung', label: 'Lektionen mit Verwaltung' },
  { key: 'lektionen_substituiert', label: 'Lektionen Substituiert' },
  // HR-v2 Phase 7/10 (Seite C): IPB-Statistik
  { key: 'ipb_saldo_distribution', label: 'IPB-Salden-Verteilung' },
  { key: 'substitution_volume', label: 'Vertretungsvolumen (pro Lektion)' },
  { key: 'payout_totals', label: 'Auszahlungssummen (Lektionen)' },
]

export interface HRExportLogEntry {
  id: string
  report_name: string
  export_format: string
  file_name: string
  file_size_bytes: number
  record_count: number | null
  exported_at: string
  is_scheduled: boolean
  download_count: number
  expires_at: string | null
}

export interface ScheduledReportEntry {
  id: string
  schedule_name: string
  schedule_description: string | null
  report_type: string
  export_format: string
  frequency: string
  day_of_week: number | null
  day_of_month: number | null
  time_of_day: string | null
  date_range_relative: string | null
  recipient_emails: string[]
  email_subject_template: string
  attach_report: boolean
  is_active: boolean
  last_run_at: string | null
  next_run_at: string | null
  run_count: number
  failure_count: number
  last_failure_reason: string | null
}

export interface ScheduledReportCreate {
  schedule_name: string
  schedule_description?: string
  report_type: string
  export_format: string
  frequency: string
  day_of_week?: number
  day_of_month?: number
  time_of_day: string
  date_range_relative?: string
  recipient_emails: string[]
  email_subject_template: string
  attach_report: boolean
}

export interface ExportTemplate {
  id: string
  template_name: string
  template_description: string | null
  export_format: 'csv' | 'xlsx' | 'pdf'
  template_config: Record<string, unknown>
  column_mapping: Record<string, { label: string; visible: boolean; format?: string; width_px?: number }>
  is_default: boolean
}

export const COLOR_PRESETS = [
  { name: 'Blau', header_bg: '#3b82f6', header_fg: '#ffffff', row_bg: '#ffffff', alt_row_bg: '#f3f4f6' },
  { name: 'Grün', header_bg: '#22c55e', header_fg: '#ffffff', row_bg: '#ffffff', alt_row_bg: '#f0fdf4' },
  { name: 'Grau', header_bg: '#6b7280', header_fg: '#ffffff', row_bg: '#ffffff', alt_row_bg: '#f9fafb' },
  { name: 'Dunkel', header_bg: '#1f2937', header_fg: '#ffffff', row_bg: '#ffffff', alt_row_bg: '#f3f4f6' },
]

export const DEFAULT_COLUMN_LABELS: Record<string, string> = {
  teacher_id: 'Lehrer ID', teacher_name: 'Lehrer',
  total_requested: 'Angefragt', total_assigned: 'Besetzt',
  total_substituted: 'Substituiert', total_minutes: 'Minuten',
  total_hours: 'Stunden', date: 'Datum',
  requester: 'Anfordernd', substitute: 'Vertretung',
  lesson_count: 'Lektionen', minutes: 'Minuten', hours: 'Stunden',
  status: 'Status', subject: 'Fach',
}
